import React, { useEffect, useState } from "react";
import { Box, Grid, Card, CardContent, Typography, CircularProgress } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import api from "../../utils/api";

const StatCard = ({ icon, title, count, backgroundColor }) => (
  <Card
    sx={{
      borderRadius: "14px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      px: 1,
      pt: 1,
      pb: 0.5,
      height: 58,
      position: "relative",
      overflow: "hidden",
      backgroundColor: "rgba(255,255,255,0.96)",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
      },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: 12,
        left: 12,
        width: 36,
        height: 36,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `${backgroundColor}18`,
        backdropFilter: "blur(8px)",
        border: `1px solid ${backgroundColor}35`,
        color: backgroundColor,
        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
      }}
    >
      {icon}
    </Box>

    <CardContent
      sx={{
        marginLeft: 5,
        pt: 0.5,
        pb: "6px !important",
      }}
    >
      <Typography
        sx={{
          color: "#6b778c",
          fontWeight: 600,
          textTransform: "uppercase",
          fontSize: 9,
          lineHeight: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 15,
          mt: 0.2,
          color: "#1f2d3d",
        }}
      >
        {count}
      </Typography>
    </CardContent>
  </Card>
);

const OverviewSummaryCards = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await api.get("/workorder-summary");
        const data = res.data || {};

        setStats([
          {
            title: "Work Orders This Month",
            count: data.thisMonth ?? "N/A",
            icon: <CalendarMonthOutlinedIcon fontSize="small" />,
            backgroundColor: "#4f8df7",
          },
          {
            title: "Resolved This Month",
            count: data.resolvedThisMonth ?? "N/A",
            icon: <CheckCircleOutlineIcon fontSize="small" />,
            backgroundColor: "#43a047",
          },
          {
            title: "Pending This Month",
            count: data.pendingThisMonth ?? "N/A",
            icon: <PendingActionsOutlinedIcon fontSize="small" />,
            backgroundColor: "#fb8c00",
          },
          {
            title: "Avg. Resolution Time",
            count:
              data.avgResolution != null ? `${data.avgResolution} days` : "N/A",
            icon: <ScheduleOutlinedIcon fontSize="small" />,
            backgroundColor: "#607d8b",
          },
        ]);
      } catch (err) {
        console.error("Error fetching summary:", err);
        setStats([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  return (
    <Box sx={{ mb: 3 }}>
      {loading ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {stats.map((item, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <StatCard
                icon={item.icon}
                title={item.title}
                count={item.count}
                backgroundColor={item.backgroundColor}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default OverviewSummaryCards;